let route = {
    path: '/modules/prepare',
    name: 'prepare-prepare',
    component: () => import('@/modules/prepare/index.vue'),
    children: [
        {
            path: 'prepareInfo',
            name: 'prepare-management',
            component: () => import('@/modules/prepare/prepareInfo.vue'),
            meta: {
                pageTitle: '配货管理',
            }
        },
        {
            path: 'prepare',
            name: 'prepare-management',
            component: () => import('@/modules/prepare/prepare.vue'),
            meta: {
                pageTitle: '配货管理',
            }
        },
        // 新增
        {
            path: 'prepareDetail',
            name: 'prepare-management-detail',
            component: () => import('@/modules/prepare/prepareDetail/index.vue'),
            meta: {
                parent: '/modules/prepare/prepare',
            }
        },
        // 审批详情
        {
            path: 'approvalDetail',
            name: 'prepare-management-detail',
            component: () => import('@/modules/prepare/approvalDetail/index.vue'),
            meta: {
                parent: '/modules/prepare/prepare',
            }
        },
        // 发货详情
        {
            path: 'deliverDetail',
            name: 'prepare-management-detail',
            component: () => import('@/modules/prepare/deliverDetail/index.vue'),
            meta: {
                parent: '/modules/prepare/prepare',
            }
        },
    ],
    meta: {
        role: 'xurui_admin'
    }
};
export const PrepareRuter = route;
